export default __webpack_public_path__ + "static/media/mana10.65adcd73.svg";